import { render, staticRenderFns } from "./SimpleDataCard.vue?vue&type=template&id=720a862d&scoped=true"
import script from "./SimpleDataCard.vue?vue&type=script&lang=js"
export * from "./SimpleDataCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a862d",
  null
  
)

export default component.exports